import { useEffect, useState } from 'react';
import { getCountries } from '../../request/countriesRequest';

const sortByCaption = (countries) =>
  [...countries].sort((a, b) => {
    if (a.Caption > b.Caption) {
      return 1;
    }
    if (b.Caption > a.Caption) {
      return -1;
    }
    return 0;
  });

// Countries are a static list — every mount used to fire its own request,
// which caused a visible lag/flash everywhere a country name is shown.
// Cache the result (and any in-flight request) at module scope so the API
// is only ever hit once per page load, no matter how many components use it.
let cachedCountries = null;
let pendingRequest = null;

const fetchCountriesOnce = () => {
  if (cachedCountries) {
    return Promise.resolve(cachedCountries);
  }
  if (!pendingRequest) {
    pendingRequest = getCountries().then(({ data }) => {
      cachedCountries = sortByCaption(data);
      return cachedCountries;
    });
  }
  return pendingRequest;
};

const useGetCountries = () => {
  const [countries, setCountries] = useState(cachedCountries || []);

  useEffect(() => {
    if (cachedCountries) {
      setCountries(cachedCountries);
      return undefined;
    }

    let isMounted = true;
    fetchCountriesOnce().then((data) => {
      if (isMounted) {
        setCountries(data);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return countries;
};

export default useGetCountries;
